import dic from '@/assets/dictionary/index.js'
import { LANG } from '@/libs/constants'

const { nav } = dic[LANG]

export const newLinks = (nav) => [
  {
    id: '1',
    label: nav.links[1],
    anchor: '#how',
  },

  {
    id: 5,
    label: nav.links[5],
    anchor: '#audit',
  },

  {
    id: '2',
    label: nav.links[2],
    anchor: '#advantages',
    form: 'transporters',
  },
  {
    id: '3',
    label: nav.links[3],
    anchor: '#advantages',
    form: 'shippers',
  },
  {
    id: '4',
    label: nav.links[4],
    anchor: '#price',
  },
]

export default {
  namespaced: true,
  state: {
    links: newLinks(nav),
  },

  mutations: {},
}
